import { render, staticRenderFns } from "./text-tip-zgy.vue?vue&type=template&id=5d3a76ea&scoped=true&"
import script from "./text-tip-zgy.vue?vue&type=script&lang=js&"
export * from "./text-tip-zgy.vue?vue&type=script&lang=js&"
import style0 from "./text-tip-zgy.vue?vue&type=style&index=0&id=5d3a76ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3a76ea",
  null
  
)

export default component.exports